var map = {
	"./apple.mp3": [
		281,
		15
	],
	"./car.mp3": [
		282,
		16
	],
	"./cat.mp3": [
		283,
		17
	],
	"./dog.mp3": [
		284,
		18
	],
	"./hello.mp3": [
		285,
		19
	],
	"./star.mp3": [
		286,
		20
	],
	"./teacher.mp3": [
		287,
		21
	],
	"./town.mp3": [
		288,
		22
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 241;
module.exports = webpackAsyncContext;